import * as React from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Routes, makeSimpleRoutePath } from '../utils/routerHelper';
import { LProps, withLocalization } from '../utils/wrappers';
import { State } from '../redux/state';
import * as selectors from '../redux/selectors';
import { Competition } from '../userApi';
import { campusesLabelFor, teamsLabelFor } from '../utils/competitionLabels';
import './mobilePrimaryNav.scss';

interface Props {
  competition: Competition;
  canViewCompetitionContent: boolean;
  isLoggedIn: boolean;
  onOpenMenu?: () => void;
}

class MobilePrimaryNav extends React.Component<LProps<Props> & RouteComponentProps<{}>> {
  public componentDidMount() {
    this.syncBodyClass(true);
  }

  public componentDidUpdate(prevProps: LProps<Props>) {
    if (
      prevProps.canViewCompetitionContent !== this.props.canViewCompetitionContent ||
      prevProps.isLoggedIn !== this.props.isLoggedIn
    ) {
      this.syncBodyClass(true);
    }
  }

  public componentWillUnmount() {
    this.syncBodyClass(false);
  }

  private syncBodyClass(enabled: boolean) {
    if (typeof document === 'undefined') {
      return;
    }
    const show = enabled && this.props.isLoggedIn && this.props.canViewCompetitionContent;
    document.body.classList.toggle('cc__has_mobile_primary_nav', show);
  }

  private itemClass(routePath: string): string {
    const path = this.props.location.pathname || '';
    const active = path === routePath || path.indexOf(routePath + '/') === 0;
    return active ? 'cc__mobile_primary_nav__item active' : 'cc__mobile_primary_nav__item';
  }

  public render() {
    const { t, competition, canViewCompetitionContent, isLoggedIn, onOpenMenu } = this.props;
    if (!isLoggedIn || !canViewCompetitionContent || !competition) {
      return null;
    }
    const campusesLabel = campusesLabelFor(competition, t('Campuses'));
    const teamsLabel = teamsLabelFor(competition, t('Teams'));
    const homePath = makeSimpleRoutePath(Routes.Dashboard, t);
    const actionsPath = makeSimpleRoutePath(Routes.Pledges, t);
    const deptsPath = makeSimpleRoutePath(Routes.Departments, t);
    const teamsPath = makeSimpleRoutePath(Routes.Teams, t);

    return (
      <nav className="cc__mobile_primary_nav" aria-label={t('Main')}>
        <Link className={this.itemClass(homePath)} to={homePath}>{t('Home')}</Link>
        <Link className={this.itemClass(actionsPath)} to={actionsPath}>{t('Actions')}</Link>
        <Link className={this.itemClass(deptsPath)} to={deptsPath}>{campusesLabel}</Link>
        <Link className={this.itemClass(teamsPath)} to={teamsPath}>{teamsLabel}</Link>
        <button
          type="button"
          className="cc__mobile_primary_nav__item"
          onClick={onOpenMenu}
          aria-label={t('Open menu')}
        >
          {t('Menu')}
        </button>
      </nav>
    );
  }
}

const mapStateToProps = (state: State): Partial<Props> => ({
  competition: state.competition,
  canViewCompetitionContent: selectors.canViewCompetitionContent(state),
  isLoggedIn: selectors.isLoggedIn(state)
});

export default compose(
  withLocalization('navigation'),
  withRouter,
  connect(mapStateToProps)
)(MobilePrimaryNav) as React.ComponentClass<{ onOpenMenu?: () => void }>;
